import { render, staticRenderFns } from "./ImageCarousel2.vue?vue&type=template&id=b6700270"
import script from "./ImageCarousel2.vue?vue&type=script&lang=js"
export * from "./ImageCarousel2.vue?vue&type=script&lang=js"
import style0 from "./ImageCarousel2.vue?vue&type=style&index=0&id=b6700270&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports